<template>
  <el-dialog :title="title" :visible.sync="visible" width="90%" :close-on-click-modal="false" append-to-body
    class="export-dialog" @close="handleClose">
    <!-- 自定义选项区域 -->
    <div v-if="hasOptions" class="export-options" style="margin-bottom: 20px">
      <slot name="options"></slot>
    </div>
    <!-- 导出内容区域 -->
    <div ref="exportContent" class="export-content">
      <slot></slot>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
      <el-button type="primary" @click="handlePrint" icon="el-icon-printer">打印</el-button>
      <el-button type="primary" @click="handleExportWord" v-loading="exportLoading"
        icon="el-icon-download">导出Word</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { exportWord, exportDocx } from '@/utils/htmlToPdf.js'

export default {
  name: 'ExportDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '导出单据'
    },
    fileName: {
      type: String,
      default: ''
    },
    hasOptions: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      exportLoading: false
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    // 打印
    handlePrint() {
      this.$nextTick(() => {
        const printContent = this.$refs.exportContent
        if (!printContent) {
          this.$message.warning('找不到打印内容')
          return
        }

        // 获取所有样式
        const styles = this.getComponentStyles()

        // 创建打印窗口
        const printWindow = window.open('', '_blank')
        printWindow.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>${this.title}</title>
            <style>
              ${styles}
              @media print {
                @page {
                  size: A4;
                  margin: 10mm;
                }
                body {
                  margin: 0;
                  padding: 0;
                }
              }
            </style>
          </head>
          <body>
            ${printContent.innerHTML}
          </body>
          </html>
        `)
        printWindow.document.close()
        printWindow.focus()
        // 等待内容加载后打印
        setTimeout(() => {
          printWindow.print()
        }, 500)
      })
    },
    // 导出Word
    handleExportWord() {
      this.$nextTick(() => {
        const $exportContent = this.$refs.exportContent
        if (!$exportContent) {
          this.$message.warning('找不到目标元素，无法导出')
          return
        }
        this.exportLoading = true
        this.$nextTick(() => {
          const now = new Date()
          const dateStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
          const fileName = this.fileName || `${this.title}_${dateStr}`
          // 优先使用真正的 docx 导出，失败时回退到原有 HTML Word 导出
          exportDocx(fileName, $exportContent, () => {
            this.exportLoading = false
          })
        })
      })
    },
    // 获取组件样式
    getComponentStyles() {
      // 获取所有样式表
      const styles = Array.from(document.styleSheets)
        .map(styleSheet => {
          try {
            return Array.from(styleSheet.cssRules)
              .map(rule => rule.cssText)
              .join('\n')
          } catch (e) {
            return ''
          }
        })
        .join('\n')

      // 添加通用打印样式
      const commonStyles = `
        body {
          margin: 0;
          padding: 20px;
          font-family: 'Microsoft YaHei', Arial, sans-serif;
        }
        table {
          border-collapse: collapse;
        }
        .export-content {
          background: #fff;
        }
      `

      return commonStyles + '\n' + styles
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$emit('open')
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .export-dialog {
  .el-dialog__body {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
  }
}

.export-options {
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
}

.export-content {
  background: #fff;
  position: relative;
}
</style>
